<template>
  <el-dialog
    title="设备识别码"
    :visible.sync="visible"
    width="520px"
    :close-on-press-escape="false"
    @closed="handleClosed">
    <el-table
      v-loading="loading"
      border
      :data="list">
      <el-table-column label="标签序号">
        <template slot-scope="{row}">
          <span> {{ row.tagNo | tagCount() }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="设备识别码"
        prop="eic">
        <template slot-scope="{row}">
          <span v-if="mode === 'view'"> {{ row.eic }}</span>
          <el-input
            v-else
            v-model="row.eic"
            placeholder="请输入设备识别码"></el-input>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="!editable"
      background
      :current-page.sync="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="total"
      @current-change="handleCurrentChange">
    </el-pagination>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">关闭</el-button>
      <template v-if="editable">
        <el-button
          v-if="mode === 'view'"
          type="primary"
          :loading="loading"
          @click="toggleMode">编辑</el-button>
        <template v-else>
          <el-button
            :loading="loading"
            @click="toggleMode">取消</el-button>
          <el-button
            type="primary"
            :loading="loading"
            @click="submit">提交</el-button>
        </template>
      </template>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'DeviceModal',
  data() {
    return {
      loading: false,
      visible: false,
      editable: false,
      mode: 'view', // view edit
      config: {
        pageNum: 1,
        pageSize: 10
      },
      list: [],
      total: 0
    }
  },
  created() { },
  mounted() { },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    toggleMode() {
      if (this.mode === 'view') {
        this.mode = 'edit'
      } else {
        this.$confirm('设备识别码未保存, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.mode = 'view'
          this.handleClosed()
          this.fetchList()
        })
      }
    },
    handleClosed() {
      this.config.pageNum = 1
      this.total = 0
      this.list = []
      this.mode = 'view'
      this.editable = false
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('batch/getbatcheics', {
        payload: {
          ...this.config
        },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    submit() {
      this.loading = true
      const tagNo2EICs = {}
      this.list.forEach(i => {
        tagNo2EICs[i.tagNo] = i.eic
      })
      this.$store.dispatch('batch/updatebatcheics', {
        payload: {
          vendorId: this.config.vendorId,
          batchId: this.config.batchId,
          tagNo2EICs
        },
        success: () => {
          this.loading = false
          this.mode = 'view'
          this.fetchList()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(options, editable) {
      this.config = {
        ...this.config,
        ...options,
        pageSize: editable ? 50 : 10
      }
      this.editable = editable
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
<style lang="stylus" scoped></style>
